
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteMigrationsRepositoryInterface, {
  MigrationType,
  WebsiteMigration,
} from '@/services/WebsiteMigrations/interfaces';
import ViewRenameMigration from '@/views/pages/website-migrations/ViewRenameMigration.vue';
import ViewServerMigration from '@/views/pages/website-migrations/ViewServerMigration.vue';

@Component({
  components: {
    ViewRenameMigration,
    ViewServerMigration,
  },
  mixins: [Themeable],
  inject: [
    'websiteMigrationsRepository',
  ],
})
export default class ViewMigration extends Vue {
  public loading: boolean = true;

  public websiteMigrationsRepository!: WebsiteMigrationsRepositoryInterface;

  public migration: WebsiteMigration = {} as WebsiteMigration;

  public migrationType: MigrationType = {
    rename: 'rename',
    mainToMain: 'migrate-main-to-main',
    subToSub: 'migrate-sub-to-sub',
  };

  public async created(): Promise<void> {
    const id = Number(this.$route.params.id);

    try {
      this.migration = await this.websiteMigrationsRepository.getMigration(id);
    } catch (err) {
      this.$errorDialog.show(
        `Error occurred while fetching website migrations, ${err?.response?.data?.error || err.message}`,
      );
    }
  }
}
